import { useEffect, useState } from 'react';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, isSameDay, parseISO } from 'date-fns';
import { projectsApi } from '@/api/projects.api';
import { PageHeader } from '@/components/layout/PageHeader';
import { Select } from '@/components/ui/Select';
import { useProjectList } from '@/modules/projects/shared/useProjectList';
import type { ProjectTask } from '@/types/projects';
import { showApiError } from '@/utils/apiError';

export function ProjectsCalendarPage() {
  const { projects } = useProjectList();
  const [projectId, setProjectId] = useState<number | undefined>();
  const [tasks, setTasks] = useState<ProjectTask[]>([]);
  const monthStart = startOfMonth(new Date());
  const days = eachDayOfInterval({ start: monthStart, end: endOfMonth(monthStart) });

  useEffect(() => {
    if (!projectId) { setTasks([]); return; }
    projectsApi.listTasks(projectId, { page: 0, size: 500 }).then((r) => setTasks(r.content)).catch((e) => showApiError(e, 'Failed to load calendar'));
  }, [projectId]);

  return (
    <div>
      <PageHeader title="Calendar" description="Milestones and task due dates"
        breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'Projects', to: '/projects' }, { label: 'Calendar' }]} />
      <Select
        className="mb-4"
        placeholder="Select project"
        value={String(projectId ?? '')}
        onChange={(v) => setProjectId(v ? Number(v) : undefined)}
        options={projects.map((p) => ({ value: String(p.id), label: p.projectName }))}
      />
      <div className="grid grid-cols-7 gap-2">
        {days.map((day) => {
          const dayTasks = tasks.filter((t) => t.dueDate && isSameDay(parseISO(t.dueDate), day));
          return (
            <div key={day.toISOString()} className="card min-h-[80px] p-2 text-xs">
              <div className="font-medium mb-1">{format(day, 'd MMM')}</div>
              {dayTasks.map((t) => <div key={t.id} className="truncate text-primary-600">{t.title}</div>)}
            </div>
          );
        })}
      </div>
    </div>
  );
}
